import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Stores } from '../../interfaces/stores';

@Component({
  selector: 'app-excel',
  templateUrl: './excel.component.html',
  styleUrl: './excel.component.css'
})
export class ExcelComponent implements OnInit {
  constructor(private api: ApiEntryControlService, private modal: NgbModal, private toast: ToastrService) { }


  ngOnInit(): void {
    if (this.facility_id > 0) {
      this.form.get('facility_id')?.setValue(this.facility_id);
      this.api.getAllStoresByFacility(this.facility_id).subscribe((res) => { this.stores = res.data as Stores[] }, e => this.toast.warning(e.error.mistakes, e.error.msg));
    }
  }
  @Input()
  facility_id: number;

  loading: boolean = false;
  pathDownload: string = null;

  stores: Stores[];

  tcheck: number = 1;
  form = new UntypedFormGroup({
    filter: new UntypedFormControl(this.tcheck),
    to: new UntypedFormControl(''),
    from: new UntypedFormControl(''),
    eto: new UntypedFormControl(''),
    efrom: new UntypedFormControl(''),
    stores_id: new UntypedFormControl(0),
    facility_id: new UntypedFormControl(0),
    users: new UntypedFormControl(true),
    employees: new UntypedFormControl(true),
    providers: new UntypedFormControl(true),
    visitors: new UntypedFormControl(true),
    name: new UntypedFormControl(true),
    lastname: new UntypedFormControl(true),
    rut: new UntypedFormControl(true),
    phone: new UntypedFormControl(true),
    email: new UntypedFormControl(true),
    state_id: new UntypedFormControl(true),
    created_at: new UntypedFormControl(true),
  });


  generateReport(mdl: any) {
    this.modal.open(mdl);
    this.loading = true;
    this.form.get('facility_id')?.setValue(this.facility_id);
    this.api.createReportExcel(this.form).subscribe(
      (rs) => {
        console.log("REPORT SUCCESS:", rs);
        this.loading = false;
        this.toast.success(rs.msg);
        let result = rs as any;
        this.pathDownload = result?.path;
      },
      e => {
        console.log("REPORT ERROR:", e);
        this.loading = false;
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
  generateReportPdf(mdl: any) {
    this.modal.open(mdl);
    this.loading = true;
    this.form.get('facility_id')?.setValue(this.facility_id);
    this.api.createReportPdf(this.form).subscribe(
      (rs) => {
        console.log("REPORT SUCCESS:", rs);
        this.loading = false;
        this.toast.success(rs.msg);
        let result = rs as any;
        this.pathDownload = result?.path;
      },
      e => {
        console.log("REPORT ERROR:", e);
        this.loading = false;
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
  setCheck(event: any) {
    console.log(event.target.value);
    this.tcheck = event.target.value;
    this.form.get('filter')?.setValue(this.tcheck);
  }
  clean() {
    this.form.reset();
  }

}
